(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awakndland-collection-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sizeAliases = {
      small: 's',
      sm: 's',
      s: 's',
      medium: 'm',
      med: 'm',
      m: 'm',
      large: 'l',
      lg: 'l',
      l: 'l',
      xlarge: 'xl',
      'x-large': 'xl',
      xl: 'xl',
      xxlarge: '2xl',
      'xx-large': '2xl',
      xxl: '2xl',
      '2x': '2xl',
      '2xl': '2xl',
      xxxlarge: '3xl',
      'xxx-large': '3xl',
      xxxl: '3xl',
      '3x': '3xl',
      '3xl': '3xl',
      '4x': '4xl',
      '4xl': '4xl',
      '5x': '5xl',
      '5xl': '5xl',
      '6x': '6xl',
      '6xl': '6xl'
    };

    const normalize = (label) => {
      const key = label.trim().toLowerCase().replace(/\s+/g, '-');
      return sizeAliases[key] || key;
    };

    const getGroupLabel = (group) => {
      const summary = group.querySelector('summary');
      const heading = summary || group.querySelector('.facets__label, .mobile-facets__summary, .facets__heading');
      return heading ? heading.textContent.trim().toLowerCase() : '';
    };

    const tidySizeFilters = () => {
      document.querySelectorAll('.facets__panel, .mobile-facets__details').forEach((group) => {
        if (!getGroupLabel(group).includes('size')) return;

        group.querySelectorAll('.show-more-item').forEach((item) => {
          item.classList.remove('hidden');
          item.hidden = false;
        });

        group.querySelectorAll('show-more-button').forEach((button) => {
          button.hidden = true;
        });

        group.querySelectorAll('button, a').forEach((control) => {
          const controlText = control.textContent.trim().toLowerCase();
          if (controlText.includes('show more') || controlText.includes('show less')) {
            control.hidden = true;
          }
        });

        const seen = new Set();
        group.querySelectorAll('.facets__item, .mobile-facets__item').forEach((item) => {
          const label = item.querySelector('.facet-checkbox__text-label');
          const input = item.querySelector('input');
          if (!label) return;

          const canonical = normalize(label.textContent);
          if (seen.has(canonical) && !(input && input.checked)) {
            item.hidden = true;
            item.classList.add('awakndland-filter-duplicate');
          } else {
            seen.add(canonical);
            item.hidden = false;
            item.classList.remove('awakndland-filter-duplicate');
          }
        });
      });
    };

    const tidyPriceFilters = () => {
      document.querySelectorAll('.facets__panel, .mobile-facets__details').forEach((group) => {
        if (!getGroupLabel(group).includes('price')) return;

        group.querySelectorAll('p, span, small').forEach((node) => {
          if (node.querySelector('input, button, a')) return;

          const helperText = node.textContent.trim();
          if (/^the highest price is/i.test(helperText)) {
            node.classList.add('awakndland-filter-helper-hidden');
          }
        });
      });
    };

    const collapseDefaultFilterPanels = () => {
      document.querySelectorAll('.facets__panel, .mobile-facets__details').forEach((group) => {
        if (group.dataset.awakndlandCollapsedDefault === 'true') return;

        const hasActiveSelection = Boolean(group.querySelector('input:checked'));
        if (group.tagName.toLowerCase() === 'details' && !hasActiveSelection) {
          group.removeAttribute('open');
          group.classList.remove('menu-opening');
        }

        group.dataset.awakndlandCollapsedDefault = 'true';
      });
    };

    const tidyFilters = () => {
      collapseDefaultFilterPanels();
      tidySizeFilters();
      tidyPriceFilters();
    };

    tidyFilters();
    document.addEventListener('DOMContentLoaded', tidyFilters);
    document.addEventListener('shopify:section:load', tidyFilters);

    const observer = new MutationObserver(() => window.requestAnimationFrame(tidyFilters));
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awakndland-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllers = new WeakMap();
    const initialize = (root) => {
      controllers.get(root)?.controller.abort();
      const controller = new AbortController();
      root.dataset.tabsInitialized = 'true';
      const heading = root.querySelector('[data-awakndland-tabs-heading]');
      const tabs = Array.from(root.querySelectorAll('[data-awakndland-tabs-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-awakndland-tabs-panel]'));
      const activate = (tab) => {
          const targetId = tab.getAttribute('aria-controls');

          for (const item of tabs) {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            item.tabIndex = isActive ? 0 : -1;
          }

          for (const panel of panels) {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          }

          if (heading && tab.dataset.heading) {
            heading.textContent = tab.dataset.heading;
          }
      };
      for (const [index, tab] of tabs.entries()) {
        tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
        tab.addEventListener('click', () => activate(tab), { signal: controller.signal });
        tab.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        }, { signal: controller.signal });
      }
      controllers.set(root, { controller, activate });
    };
    const within = (scope) => {
      const roots = Array.from(scope.querySelectorAll('[data-awakndland-tabs]'));
      if (scope.matches?.('[data-awakndland-tabs]')) roots.unshift(scope);
      return roots;
    };
    const initializeWithin = (scope) => within(scope).forEach(initialize);
    initializeWithin(document);
    document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', event => {
      within(event.target).forEach(root => {
        controllers.get(root)?.controller.abort();
        controllers.delete(root);
        delete root.dataset.tabsInitialized;
      });
    });
    document.addEventListener('shopify:block:select', event => {
      const root = event.target.closest?.('[data-awakndland-tabs]');
      if (!root) return;
      const tab = Array.from(root.querySelectorAll('[data-awakndland-tabs-tab]')).find(item => item.dataset.awakndlandTabsBlock === event.detail?.blockId);
      if (tab) controllers.get(root)?.activate(tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awakndland-header-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class AwakndlandCartCount extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.eventController = new AbortController();
        const options = { signal: this.eventController.signal };
        const onCartUpdate = (event) => this.updateCount(event.detail?.data || event.detail);

        ['cart:updated', 'GiftWrapUpdateEvent', 'DiscountUpdateEvent'].forEach((name) => {
          document.addEventListener(name, onCartUpdate, options);
        });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.updateCount();
        }, options);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            this.updateCount(event?.cartData);
          });
        }
      }

      disconnectedCallback() {
        this.requestId = (this.requestId || 0) + 1;
        this.eventController?.abort();
        this.fetchController?.abort();
        this.unsubscribeCart?.();
        this.unsubscribeCart = null;
      }

      renderCount(count) {
        if (!Number.isInteger(count) || count < 0 || !this.isConnected) return false;
        this.textContent = this.dataset.cartLabel + (count > 0 ? ` (${count})` : '');
        this.closest('a')?.setAttribute('aria-label', count > 0
          ? this.dataset.cartCountLabel.replace('[count]', count)
          : this.dataset.cartEmptyLabel);
        return true;
      }

      async updateCount(cart) {
        const requestId = ++this.requestId;
        this.fetchController?.abort();
        if (this.renderCount(cart?.item_count)) return;

        this.fetchController = new AbortController();
        try {
          const response = await fetch(this.dataset.cartUrl, {
            signal: this.fetchController.signal,
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const currentCart = await response.json();
          if (requestId === this.requestId) this.renderCount(currentCart.item_count);
        } catch {
          return;
        }
      }
    }

    if (!customElements.get('awakndland-cart-count')) {
      customElements.define('awakndland-cart-count', AwakndlandCartCount);
    }

    const initHeader = (header) => {
      if (!header || header.dataset.awakndlandHeaderReady === 'true') return;

      const search = header.querySelector('[data-awakndland-header-search]');
      const searchInput = search?.querySelector('input[type="search"]');
      const searchSummary = search?.querySelector('summary');
      const shopMenus = Array.from(header.querySelectorAll('[data-awakndland-header-shop]'));
      if (!search || !searchInput || !searchSummary) return;

      header.dataset.awakndlandHeaderReady = 'true';
      header.awakndlandHeaderController = new AbortController();
      const listenerOptions = { signal: header.awakndlandHeaderController.signal };

      search.addEventListener('toggle', () => {
        if (!search.open) return;
        shopMenus.forEach((menu) => {
          menu.open = false;
        });
        window.requestAnimationFrame(() => searchInput.focus());
      }, listenerOptions);

      shopMenus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (menu.open) search.open = false;
        }, listenerOptions);
        menu.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' && event.target === menu.querySelector('summary')) {
            event.preventDefault();
            menu.open = true;
            window.requestAnimationFrame(() => menu.querySelector('a')?.focus());
            return;
          }
          if (event.key !== 'Escape' || !menu.open) return;
          event.preventDefault();
          event.stopPropagation();
          menu.open = false;
          menu.querySelector('summary')?.focus();
        }, listenerOptions);
      });

      document.addEventListener('focusin', (event) => {
        shopMenus.forEach((menu) => {
          if (menu.open && !menu.contains(event.target)) menu.open = false;
        });
      }, listenerOptions);

      search.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        search.open = false;
        searchSummary.focus();
      }, listenerOptions);

      document.addEventListener('click', (event) => {
        if (search.open && !search.contains(event.target)) search.open = false;
        shopMenus.forEach((menu) => {
          if (menu.open && !menu.contains(event.target)) menu.open = false;
        });
      }, listenerOptions);
    };

    const bootHeaders = () => {
      document.querySelectorAll('.awakndland-header-nav').forEach(initHeader);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootHeaders);
    } else {
      bootHeaders();
    }

    document.addEventListener('shopify:section:load', bootHeaders);
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.awakndland-header-nav').forEach((header) => {
        header.awakndlandHeaderController?.abort();
        delete header.dataset.awakndlandHeaderReady;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awakndland-home-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('awakndland-focus')) {
    class AwakndlandFocus extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        const pairs = Array.from(this.querySelectorAll('[data-focus-pair]'));
        this._pairs = pairs.map(node => ({ node, key: node.dataset.focusKey,
          rail: node.querySelector('[data-focus-rail]'), panels: Array.from(node.querySelectorAll('[data-focus-panel]')),
          controls: node.querySelector('[data-focus-controls]'), buttons: Array.from(node.querySelectorAll('[data-focus-view]')),
          count: node.querySelector('[data-focus-count]'), status: node.querySelector('[data-focus-status]'),
          swipe: node.querySelector('[data-focus-swipe]'), another: node.querySelector('[data-focus-another]')
        }));
        if (!this._pairs.length || this._pairs.some(pair => !pair.key || !pair.rail || !pair.controls || !pair.count || !pair.status || !pair.swipe || !pair.another || pair.panels.length !== 2 || pair.buttons.length !== 2 || pair.buttons.some((button, index) => button.getAttribute('aria-controls') !== pair.panels[index].id))) return;
        this._connected = true;
        this._listeners = [];
        this._media = window.matchMedia('(max-width: 749px)');
        this._view = 0;
        this._storageKey = 'awakndland-focus-v3:' + this.dataset.sectionId;
        for (const pair of this._pairs) {
          pair.controls.hidden = false;
          pair.swipe.hidden = false;
          pair.another.hidden = this._pairs.length < 2;
          pair.buttons.forEach((button, index) => {
            this._listen(button, 'click', () => this._showView(index));
            this._listen(button, 'keydown', event => this._key(event, index));
          });
          this._listen(pair.rail, 'scroll', () => this._scroll(pair), { passive: true });
          this._listen(pair.another, 'click', () => this._chooseAnother());
        }
        this._listen(this, 'shopify:block:select', event => {
          const pair = this._pairs.find(item => item.node.dataset.focusBlock === String(event.detail?.blockId));
          if (pair) this._selectPair(pair, false);
        });
        this._onMedia = () => this._showView(this._view);
        if (this._media.addEventListener) this._media.addEventListener('change', this._onMedia);
        else if (this._media.addListener) this._media.addListener(this._onMedia);
        let pinned = this._selectedKey;
        try { pinned = window.sessionStorage.getItem(this._storageKey) || pinned; } catch {}
        this._selectPair(this._pairs.find(pair => pair.key === pinned) || this._random(this._pairs), false);
      }
      disconnectedCallback() {
        if (!this._connected) return;
        for (const [node, name, callback, options] of this._listeners) node.removeEventListener(name, callback, options);
        if (this._media.removeEventListener) this._media.removeEventListener('change', this._onMedia);
        else if (this._media.removeListener) this._media.removeListener(this._onMedia);
        for (const pair of this._pairs) { pair.controls.hidden = true; pair.swipe.hidden = true; pair.another.hidden = true; }
        this._listeners = [];
        this._connected = false;
      }
      _listen(node, name, callback, options) { node.addEventListener(name, callback, options); this._listeners.push([node, name, callback, options]); }
      _random(pairs) {
        if (pairs.length === 1) return pairs[0];
        let fraction = Math.random();
        try { if (window.crypto?.getRandomValues) { const value = new Uint32Array(1); window.crypto.getRandomValues(value); fraction = value[0] / 4294967296; } } catch {}
        return pairs[Math.floor(fraction * pairs.length)];
      }
      _selectPair(pair, moveFocus) {
        if (!pair || !this._pairs.includes(pair)) return;
        this._selectedKey = pair.key;
        this._selected = pair;
        this._pairs.forEach(item => { item.node.hidden = item !== pair; });
        try { window.sessionStorage.setItem(this._storageKey, pair.key); } catch {}
        pair.rail.scrollTo({ left: 0, behavior: 'auto' });
        this._markView(0, false);
        if (moveFocus) pair.another.focus({ preventScroll: true });
      }
      _chooseAnother() { const alternatives = this._pairs.filter(pair => pair !== this._selected); if (alternatives.length) this._selectPair(this._random(alternatives), true); }
      _markView(index, moveFocus) {
        if (!Number.isInteger(index) || index < 0 || index > 1 || !this._selected) return;
        this._view = index;
        const pair = this._selected;
        pair.buttons.forEach((button, position) => { button.setAttribute('aria-pressed', String(position === index)); if (moveFocus && position === index) button.focus({ preventScroll: true }); });
        pair.count.textContent = (index + 1) + ' / 2';
        const label = pair.buttons[index].querySelector('[data-focus-label]').textContent.trim();
        pair.status.textContent = this.dataset.statusFormat.replace('__LABEL__', label).replace('__INDEX__', String(index + 1)).replace('__TOTAL__', '2');
      }
      _showView(index, moveFocus = false) {
        if (!Number.isInteger(index) || index < 0 || index > 1 || !this._selected) return;
        this._markView(index, moveFocus);
        if (this._media.matches) {
          const pair = this._selected;
          pair.rail.scrollTo({ left: pair.panels[index].offsetLeft - pair.panels[0].offsetLeft, behavior: 'auto' });
        }
      }
      _scroll(pair) {
        if (!this._media.matches || pair !== this._selected) return;
        const distance = pair.panels[1].offsetLeft - pair.panels[0].offsetLeft;
        if (distance !== 0) this._markView(pair.rail.scrollLeft / distance > 0.5 ? 1 : 0, false);
      }
      _key(event, index) {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') next = 1 - index;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = 1;
        if (next !== undefined) { event.preventDefault(); this._showView(next, true); }
      }
    }
    customElements.define('awakndland-focus', AwakndlandFocus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awakndland-live-refinement-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('awakndland-home-hero')) {
    customElements.define('awakndland-home-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const rail = this.querySelector('[data-hero-gallery]');
        const controls = this.querySelector('[data-hero-controls]');
        if (!rail || !controls) return;
        controls.hidden = false;
        controls.addEventListener('click', event => {
          const previous = event.target.closest('[data-hero-previous]');
          const next = event.target.closest('[data-hero-next]');
          if (!previous && !next) return;
          const target = previous ? rail.firstElementChild : rail.lastElementChild;
          rail.scrollTo({ left: target.offsetLeft - rail.firstElementChild.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
class AwakndlandCollectionResults extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.refresh();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  updateCount(countText) {
    document.querySelectorAll('.results-count, #ProductCount, #ProductCountMobile, .mobile-facets__count').forEach(el => {
      const target = el.querySelector('[id^="ProductCount"]') || el;
      target.textContent = countText;
      target.classList.remove('loading');
    });
  }

  async refresh() {
    await Promise.resolve();
    if (this.dataset.stockFilter !== 'true') {
      const count = this.querySelector('#ProductCount');
      if (count) this.updateCount(count.textContent.trim());
      this.dataset.resultsComplete = 'true';
      return;
    }
    const grid = this.querySelector('.product-grid');
    if (!grid) return;
    const sourcePage = Number(this.dataset.nativePage);
    const pages = Number(this.dataset.nativePages);
    const size = Number(this.dataset.pageSize);
    const base = new URL(window.location.href);
    const extendedSizes = this.dataset.extendedSizes === 'true';
    const logicalPageParam = extendedSizes ? 'aw_page' : 'page';
    const requestedPage = Math.max(1, Number(base.searchParams.get(logicalPageParam) || base.searchParams.get('page')) || 1);
    const batches = new Map([[sourcePage, [...grid.querySelectorAll('[data-product-id]')]]]);
    this.setAttribute('aria-busy', 'true');
    try {
      for (let page = 1; page <= pages; page++) {
        if (page === sourcePage) continue;
        const url = new URL(base);
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('page', String(page));
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Collection page request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('awakndland-collection-results');
        if (!source || source.dataset.section !== this.dataset.section || Number(source.dataset.nativePages) !== pages) throw new Error('Collection changed during request');
        batches.set(page, [...source.querySelectorAll('.product-grid [data-product-id]')]);
      }
      if (!this.isConnected || this.controller.signal.aborted) return;
      const seen = new Set();
      const rows = [...batches].sort(([a], [b]) => a - b).flatMap(([, rows]) => rows).filter(row => {
        if (seen.has(row.dataset.productId)) return false;
        seen.add(row.dataset.productId);
        return true;
      });
      if (extendedSizes) {
        const sort = base.searchParams.get('sort_by') || this.dataset.sort;
        if (sort === 'price-ascending' || sort === 'price-descending') {
          const direction = sort === 'price-ascending' ? 1 : -1;
          rows.sort((a, b) => direction * (Number(a.dataset.eligiblePrice) - Number(b.dataset.eligiblePrice)));
        }
      }
      const total = rows.length;
      const totalPages = Math.max(1, Math.ceil(total / size));
      const page = Math.min(requestedPage, totalPages);
      grid.replaceChildren(...rows.slice((page - 1) * size, page * size));
      Object.assign(grid.dataset, {currentPage: String(page), totalPages: String(totalPages), lastPage: String(totalPages), totalItems: String(total), pageSize: String(size)});
      this.querySelector('[data-collection-empty]').hidden = total > 0;
      const countText = total === 1 ? this.dataset.countOne : this.dataset.countOther.replace('__COUNT__', String(total));
      this.updateCount(countText);
      const pagination = this.querySelector('[data-collection-pagination]');
      pagination.replaceChildren();
      if (totalPages > 1) {
        const nav = document.createElement('nav');
        nav.className = 'awakndland-stock-pagination';
        nav.setAttribute('aria-label', this.dataset.pageLabel.replace('__PAGE__', String(page)).replace('__PAGES__', String(totalPages)));
        const link = (number, label) => {
          const a = document.createElement('a');
          const url = new URL(base);
          url.searchParams.delete('section_id');
          if (extendedSizes) url.searchParams.delete('page');
          if (number === 1) url.searchParams.delete(logicalPageParam); else url.searchParams.set(logicalPageParam, String(number));
          a.href = url.pathname + url.search;
          a.textContent = label;
          return a;
        };
        if (page > 1) nav.append(link(page - 1, this.dataset.previous));
        const label = document.createElement('span');
        label.textContent = this.dataset.pageLabel.replace('__PAGE__', String(page)).replace('__PAGES__', String(totalPages));
        nav.append(label);
        if (page < totalPages) nav.append(link(page + 1, this.dataset.next));
        pagination.append(nav);
      }
      if (page !== requestedPage || extendedSizes && base.searchParams.has('page')) {
        if (extendedSizes) base.searchParams.delete('page');
        if (page === 1) base.searchParams.delete(logicalPageParam); else base.searchParams.set(logicalPageParam, String(page));
        history.replaceState({searchParams: base.searchParams.toString()}, '', base.pathname + base.search);
      }
      this.dataset.total = String(total);
      this.dataset.resultsComplete = 'true';
    } catch (error) {
      if (error.name !== 'AbortError' && this.isConnected) {
        const message = this.querySelector('[data-collection-error]');
        message.textContent = this.dataset.error;
        message.hidden = false;
        this.dataset.resultsComplete = 'error';
      }
    } finally {
      if (this.isConnected) this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('awakndland-collection-results')) customElements.define('awakndland-collection-results', AwakndlandCollectionResults);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
